
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/run",
      function () {
        return require("private-next-pages/run.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/run"])
      });
    }
  